/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const ProjectAttributes = {
  _listenToAttributeChange(e) {
    return $('select[name=project_attributes]', this.$el).on('change', e => {
      let value;
      const $attributeInputs = $('.value input, .value select', this.$el);
      $attributeInputs.addClass('hide');

      $.each($attributeInputs, function(_, attrSelect) {
        if ($(attrSelect).is('[multiple]')) {
          $(attrSelect).next().addClass('hide');
          return $(attrSelect).next().find('.selectize-dropdown').addClass('hide');
        }
      });

      if (value = e.target.value) {
        const $targetInput = $(`[data-id='${value}']`);
        $targetInput.removeClass('hide').prop('disabled', false);

        if ($targetInput.is('[multiple]')) {
          const $selectizeInput = $(`[data-id='${value}']`, this.$el);
          if ($selectizeInput[0].selectize) {
            $selectizeInput[0].selectize.clear();
            const $selectizeDivs = $selectizeInput.next();
            $selectizeDivs.removeClass('hide');
            return $selectizeDivs.children().removeClass('hide');
          } else {
            return $selectizeInput.removeClass('hide').selectize({plugins: ['remove_button']})[0].selectize.clear();
          }
        }
      } else {
        return $('#project_value', this.$el).removeClass('hide');
      }
    });
  },

  _listenToAddButton(e) {
    return $('a.add', this.$el).on('click', e => {
      let oldValues;
      e.preventDefault();

      const selectedAttribute = $('select[name=project_attributes]', this.$el).find('option:selected');
      const attributeName = selectedAttribute.text();
      const attributeId = selectedAttribute.val();

      const $value = $(`.value [data-id=${attributeId}]`, this.$el).exists().prop('disabled', true);

      this._removeAttributeFromSelect(attributeId);

      if ($value[0].selectize) {
        oldValues = $value[0].selectize.getValue();
        $value[0].selectize.destroy();
      }

      const $attribute = $(`<div class='columns small-8 medium-4'><span data-id=${attributeId}>${attributeName}</span></div>`);
      const $button = $(`<div class='columns small-2 end'><a class='remove tip-right' data-tooltip title='${'Remove'}'><i class='pti pt-close'></i></a></div>`);
      const $projectRow = $('<div class="row"/>').append($(`<div class='columns small-4'><label>${I18n.t('v4.projects.project_attributes.attributes')}</label></div>`), $attribute, $('<div class="columns small-8 medium-6 last"/>').append($value.clone().prop('disabled', false).removeClass('hide')), $button);
      $('.selected-attributes .row.new', this.$el).before($projectRow);
      $('.selected-attributes .remove[data-tooltip]').foundation('tooltip');
      if ($projectRow.find('[multiple]').length) {
        return $projectRow.find('[multiple]').selectize({plugins: ['remove_button']})[0].selectize.setValue(oldValues);
      }
    });
  },

  _listenToRemoveButton(e) {
    return $(document).on('click', '.end a.remove', e => {
      e.preventDefault();
      const $target = $(e.currentTarget);
      const $parent = $target.parents('.row');

      const id = $parent.find('span[data-id]').data('id');
      $('.new .value').find(`[data-id=${id}]`).exists().prop('disabled', false).val('');

      const option = _.find(this.addedAttributeIds, {value: String(id)});
      this.attributesSelectize.addOption(option);
      this.attributesSelectize.refreshOptions(false);

      const $removedInput = $parent.find(`select[data-id=${id}], input[data-id=${id}]`);

      if ($removedInput.is('[multiple]')) {
        $removedInput[0].selectize.destroy();
      } else {
        $removedInput.remove();
      }

      $(e.target).closest('.row').remove();
      $('#' + $target.data('selector')).remove();
      return $('select[name=project_attributes]', this.$el).val('').trigger('change');
    });
  },

  _removeAttributeFromSelect(id) {
    this.addedAttributeIds.push(this.attributesSelectize.options[id]);
    return this.attributesSelectize.removeOption(id);
  },

  _addAttributeToSelect(id) {
    const option = _.find(this.addedAttributeIds, {value: String(id)});
    this.attributesSelectize.addOption(option);
    return this.attributesSelectize.refreshOptions(false);
  },

  _initializeSelectize() {
    this.attributesSelectize = $('select[name=project_attributes]', this.$el).exists().selectize({plugins: ['remove_button']})[0].selectize;
    this.addedAttributeIds = [];
    return _.each($('span[data-id]', this.$el), el => {
      const id = $(el).data('id');
      return this._removeAttributeFromSelect(id);
    });
  },

  initialize($el) {
    this.$el = $el;
    this._initializeSelectize();
    this._listenToAttributeChange();
    this._listenToAddButton();
    return this._listenToRemoveButton();
  }
};

module.exports = ProjectAttributes.initialize.bind(ProjectAttributes);
